<style lang="scss" scoped>
.link-field {
    position: relative;

    input {
        border-width: 0;
        border-radius: 4px;
        background-color: #f8f8f8 !important;
        height: 44px;
        color: #172340;
        font-size: 1.25rem;
        padding-left: 16px;
        padding-right: 120px;
        font-weight: 200;
        text-overflow: ellipsis;
    }
    .copy {
        position: absolute;
        top: 50%;
        right: 16px;
        transform: translateY(-50%);

        a {
            color: var(--accent);
            font-size: 1.25rem;
            text-decoration: underline;
            font-weight: 200;
        }
    }
}

.tooltip {
    padding: 10px 16px;
    font-size: 1.25rem;
    font-weight: 300;
    line-height: 2.125rem;
    margin-right: 0;
    width: 180px;
}

.export {
    color: #172340;
    font-size: 1rem;
    font-weight: 400;
    transition: color 0.15s;

    span {
        display: inline-block;
        margin-right: 8px;

        ::v-deep svg {
            width: 16px;
            height: 16px;
            transform: translateY(-2px);
        }
    }

    &:hover {
        color: var(--accent);
        text-decoration: none;
    }
}

.label {
    width: 100%;
    color: var(--accent);
    font-weight: 600;
    font-size: 1rem;
    line-height: 19px;
    margin-bottom: 16px;
}

::v-deep .vue-input-tag-wrapper {
    border: none;
    padding: 0;

    .input-tag {
        background-color: #fdf4e9;
        border: none;
        color: #172340;
        padding: 4px 8px;
        line-height: 1;
        font-size: 0.875rem;
        margin: 0 8px 8px 0;

        .remove:empty:before {
            content: url("/svg/close-small-black.svg");
            padding-left: 8px;
        }
    }

    input {
        background: #fff !important;
        font-size: 1rem;
        font-weight: 300;
        line-height: 19px;
        border-radius: 0px;
        height: 29px;
        outline: none;
        border: none;
        border-bottom: 1px solid #cccccc;
        width: 100%;
        color: var(--dark);
        transition: border 0.15s ease-in-out;
        padding: 10px 0;
        display: block;
        margin: 0;

        &::placeholder {
            color: #6c757d;
        }

        &:focus {
            outline: none;
            box-shadow: none;
            border-color: var(--accent);
        }
    }
}

.toggle {
    color: #172340;
    font-size: 1.25rem;
    font-weight: 500;
    line-height: 1.875rem;
    position: relative;
    padding-left: 6px;
    padding-right: 6px;
    -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */
    -khtml-user-select: none; /* Konqueror HTML */
    -moz-user-select: none; /* Old versions of Firefox */
    -ms-user-select: none; /* Internet Explorer/Edge */
    user-select: none; /* Non-prefixed version, currently
                                  supported by Chrome, Opera and Firefox */

    &:after {
        content: "";
        position: absolute;
        top: 50%;
        transform: translateY(-1px);
        left: 100%;
        width: 0;
        height: 0;
        border-style: solid;
        border-width: 6px 4.5px 0 4.5px;
        border-color: #152440 transparent transparent transparent;
    }
}

.privacy {
    label {
        cursor: pointer;
        -webkit-touch-callout: none; /* iOS Safari */
        -webkit-user-select: none; /* Safari */
        -khtml-user-select: none; /* Konqueror HTML */
        -moz-user-select: none; /* Old versions of Firefox */
        -ms-user-select: none; /* Internet Explorer/Edge */
        user-select: none; /* Non-prefixed version, currently
                                  supported by Chrome, Opera and Firefox */
    }
}
.success-message {
    font-size: 1rem;
    line-height: 1.5;
    transition: opacity 0.3s, visibility 0s 0s;
    visibility: hidden;
    opacity: 0;

    &.visible {
        visibility: visible;
        opacity: 1;
    }
}

.btn-toolbar {
    .btn:focus {
        outline: none !important;
        box-shadow: none !important;
    }
    .bg-white:hover {
        background-color: var(--accent-light) !important;
    }
}
</style>

<template>
    <div class="popup px-16 py-24 p-md-24 p-lg-56" ref="fixBottom">
        <div class="close" @click="$emit('close')"></div>
        <h2 class="mb-32">Deel je teamdag</h2>
        <p class="mb-24">
            Vul e-mailadressen in, kopieer de link, of download een PDF. Kies
            hoe anderen jouw planning zien: bekijken, bewerken of dupliceren.
        </p>

        <ValidationObserver
            v-slot="{ invalid }"
            tag="div"
            :slim="true"
            ref="observer"
        >
            <div class="row mb-40">
                <div class="col-12 ">
                    <label class="label">{{
                        translations.share_popup.emails
                    }}</label>
                    <input-tag
                        v-model="emails"
                        :add-tag-on-blur="true"
                        :placeholder="translations.share_popup.emails"
                        :validate="'email'"
                        @input="tagsChanged"
                    ></input-tag>
                </div>
            </div>

            <!--
            <ValidationProvider
                ref="provider"
                vid="privacy_policy"
                :name="translations.share_popup.privacy_policy"
                :rules="'required'"
                :bails="false"
                v-slot="{ classes, errors }"
            >
                <div
                    class="privacy d-flex align-items-center"
                    @click="privacyPolicy = !privacyPolicy"
                >
                    <el-checkbox :value="privacyPolicy"></el-checkbox>
                    <label
                        class="ml-12 mb-0 font-weight-light"
                        :for="translations.share_popup.privacy_policy"
                        v-html="privacyPolicyLinkText"
                    ></label>
                </div>

                
            </ValidationProvider>-->

            <p class="label">
                De ontvanger mag je dag samenstelling:
            </p>

            <div class="btn-toolbar mb-64" role="toolbar">
                <div class="btn-group flex-1" role="group">
                    <button
                        @click.prevent="setMode('read')"
                        type="button"
                        :class="
                            mode === 'read'
                                ? 'text-white'
                                : 'bg-white text-accent'
                        "
                        class="btn flex-1 btn-accent "
                    >
                        Bekijken
                    </button>
                    <button
                        @click.prevent="setMode('edit')"
                        type="button"
                        :class="
                            mode === 'edit'
                                ? 'text-white'
                                : 'bg-white text-accent'
                        "
                        class="btn flex-1 btn-accent"
                    >
                        Bewerken
                    </button>
                    <button
                        @click.prevent="setMode('clone')"
                        type="button"
                        :class="
                            mode === 'clone'
                                ? 'text-white'
                                : 'bg-white text-accent'
                        "
                        class="btn flex-1 btn-accent"
                    >
                        Dupliceren
                    </button>
                </div>
            </div>

            <div
                class="d-flex justify-content-between align-items-center mt-24 mt-md-40"
            >
                <div
                    class="d-flex align-self-stretch justify-content-between flex-column"
                >
                    <div
                        class="position-relative d-flex"
                    >
                        <a
                            v-clipboard:copy="shareLink"
                            v-clipboard:success="onCopy"
                            class="export"
                            ><span v-html="svg('link', 'icon')"></span>Link
                            kopiëren</a
                        >
                        <span
                            class="tooltip tooltip-top"
                            :class="{ visible: copied }"
                            >{{ translations.share_popup.copied }}</span
                        >
                    </div>
                    <a
                        :href="route('schedule-pdf', [localSchedule.id])"
                        target="_blank"
                        class="export"
                        ><span v-html="svg('export', 'icon')"></span
                        >{{ translations.save_popup.export_pdf }}</a
                    >
                </div>

                <button
                    type="submit"
                    class="btn btn-accent text-white"
                    :disabled="
                        invalid ||
                            emails.length === 0 ||
                            submitted ||
                            !acceptedPrivacyPolicy
                    "
                    @click.stop="submit"
                >
                    {{ translations.share_popup.send }}
                </button>
            </div>
        </ValidationObserver>
    </div>
</template>

<script>
var cloneDeep = require("lodash.clonedeep");
import InputTag from "vue-input-tag";
import core from "../day-configurator-core";
import safariFixedBottom from "../../mixins/safari-fixed-bottom";
import hasForm from "../../mixins/has-form";
import { ValidationObserver, ValidationProvider, validate } from "vee-validate";
import { extend } from "vee-validate";
import * as rules from "vee-validate/dist/rules";
import nl from "vee-validate/dist/locale/nl.json";
for (let rule in rules) {
    extend(rule, {
        ...rules[rule],
        message: nl.messages[rule]
    });
}

export default {
    components: { ValidationObserver, ValidationProvider, InputTag },

    mixins: [core, safariFixedBottom, hasForm],

    props: {
        localSchedule: {
            type: Object,
            required: true
        }
    },

    data: () => ({
        publicUrl: "",
        privateUrl: "",
        templateUrl: "",
        emails: [],
        oldEmails: [],
        privacyPolicy: true,
        mode: "read",
        submitted: false,
        copied: false
    }),

    mounted() {
        this.emails = Array.from(
            cloneDeep(this.localSchedule.shares),
            x => x.email
        );
        this.oldEmails = this.emails;
        this.publicUrl = `${route("nl.day-configurator")}/gedeeld/${
            this.localSchedule.public_key
        }`;
        this.templateUrl = `${route("nl.day-configurator")}/sjabloon/${
            this.localSchedule.public_key
        }`;
        this.privateUrl = route("nl.day-configurator", [this.localSchedule.id]);
    },

    methods: {
        submit() {
            const self = this;
            this.beforeSubmit();

            this.$store
                .dispatch(
                    "dayConfigurator/updateShares",
                    this.emails.map(email => {
                        return {
                            email: email,
                            mode: self.mode
                        };
                    })
                )
                .then(() => {
                    this.$store
                        .dispatch("dayConfigurator/update", {
                            schedule: this.schedule,
                            set: false
                        })
                        .then(() => {
                            this.handleSuccess();
                            this.submitted = true;
                            setTimeout(() => {
                                this.submitted = false;
                            }, 5000);
                            self.$toasted.show(
                                self.translations.share_popup.save_mail_success,
                                {
                                    action: {
                                        text: "Sluiten",
                                        onClick: (e, toastObject) => {
                                            toastObject.goAway(0);
                                        }
                                    },
                                    duration: 5000
                                }
                            );
                        });
                });
        },

        onCopy() {
            this.copied = true;
            setTimeout(() => {
                this.copied = false;
            }, 3000);
        },

        setMode(mode) {
            this.mode = mode;
        },

        tagsChanged() {
            const self = this;
            if (this.oldEmails.length > this.emails) {
                this.$store
                    .dispatch(
                        "dayConfigurator/updateShares",
                        this.emails.map(email => {
                            return {
                                email: email,
                                mode: self.mode
                            };
                        })
                    )
                    .then(() => {
                        this.$store.dispatch("dayConfigurator/update", {
                            schedule: this.schedule,
                            set: false
                        });
                    });
            }
            this.oldEmails = this.emails;
        }
    },

    computed: {
        acceptedPrivacyPolicy() {
            return this.privacyPolicy === true;
        },

        privacyPolicyLinkText: function() {
            let output = this.translations.share_popup.privacy_policy;
            let privacyPolicyLink = route("nl.legal", ["privacy-policy"]);

            if ((output.match(/%s/g) || []).length == 2) {
                //only replace if 2 hashtags are present in the string
                let i = 0;
                let anchorReplacements = [
                    `<a class=\"text-accent\" target=\"_blank\" href=\"${privacyPolicyLink}\">`,
                    "</a>"
                ];
                output = output.replace(/%s/g, function(matched) {
                    let replacement = anchorReplacements[i];
                    i++;
                    return replacement;
                });
            }

            return output;
        },

        shareLink() {
            switch (this.mode) {
                case "read":
                    return this.publicUrl;
                case "edit":
                    return this.privateUrl;
                case "clone":
                    return this.templateUrl;
            }
        }
    }
};
</script>
